import { render, staticRenderFns } from "./LeadlikeTable.vue?vue&type=template&id=68be5062&scoped=true&"
import script from "./LeadlikeTable.vue?vue&type=script&lang=js&"
export * from "./LeadlikeTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadlikeTable.vue?vue&type=style&index=0&id=68be5062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be5062",
  null
  
)

export default component.exports